// EFOcatsの元クラス読込み
import EFOcats from '../../../js/v1/efocats.js';
import EFOcats_retro_settingdata from '../setting/efocats_retro_settingdata.js';
import EFOcats_retro_making from '../making/efocats_retro_making.js';
import EFOcats_validates_retro from '../validate/efocats_retro_validates.js';
import EFOcats_event_retro from '../event/efocats_event_retro.js';
import EFOcats_import_style from '../../../core/v1/import/efocats_import_style.js';
import EFOcats_import_html from '../../../core/v1/import/efocats_import_html.js';
// import EFOcats_import_lang from '../../../core/v1/import/efocats_import_lang.js';
import EFOcats_retro_submit from '../submit/efocats_retro_submit.js';

// 動作確認用の案件クラスの実装
class EFOcats_retro extends EFOcats {
  constructor() {
    super();

    // アカウント設定
    this.account = {
      id: 82,
      form_id: 2,
    };

    EFOcats_import_style.load(require('../html/export-style.html'));
    // EFOcats_import_lang.load(require('../lang/export-lang-retro.js'));
    EFOcats_import_html.load(require('../html/export-html-retro.html'));

    // 許可デバイス
    this.AllowDevices = ['SP'];

    // 元フォーム取得用のセレクタ
    this.formQuery = '.wpcf7-form';

    this.settingdata = new EFOcats_retro_settingdata();

    // // 処理クラスをカスタマイズしたものに差し替える
    this.making = new EFOcats_retro_making();

    // // イベント追加
    this.events = new EFOcats_event_retro();

    // // バリデーション追加
    this.validations = new EFOcats_validates_retro();

    // パスワード関連
    this.pass = {
      min: 6,
      max: 20,
      limit: [],
    };

    this.submit = new EFOcats_retro_submit();

    // フレーム設置先
    this.targetQurey = 'body';
  }
}

// 実行
window.efocats = new EFOcats_retro();
efocats.main();
